import { render, staticRenderFns } from "./acordion.vue?vue&type=template&id=187b855a&scoped=true&"
import script from "./acordion.vue?vue&type=script&lang=js&"
export * from "./acordion.vue?vue&type=script&lang=js&"
import style0 from "./acordion.vue?vue&type=style&index=0&id=187b855a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b855a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
